import { useQuery } from "@tanstack/react-query";
import Table from "components/shared/tables/Table";
import { useTable } from "components/shared/tables/Table/hooks/useTable";
import { useColumns } from "features/TraxxionProfile/sections/History/Job/useColumns";
import useApi from "../../../../../utils/api";

function Job({ user }: any) {
    const { authGet } = useApi();
    const columns = useColumns({ canViewRates: true });

    const { data, isLoading } = useQuery({
        queryKey: [`/users/${user?.id}/job-history`],
        queryFn: ({ queryKey }: any) => {
            const [url] = queryKey;
            return authGet(url);
        },
        enabled: !!user?.id,
    });

    const table = useTable({
        data: data?.result || [],
        totalItems: data?.totalItems || 0,
        columns,
        loading: isLoading,
        enableRowSelection: false,
        enableSorting: false,
        pagination: false,
    });

    return <Table table={table} />;
}

export default Job;
